document.querySelectorAll('a[data-cta-type="js-form-popup"').forEach((element) => {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    // event.stopPropagation();
    let target = this.getAttribute('data-cta-target');
    let popupOverlay = document.querySelector('#forms-overlay');
    popupOverlay.setAttribute('data-cta-target', target);
    document.querySelector(target).style.display = "flex";
    popupOverlay.style.display = "block";
    document.body.style.overflow = "hidden";
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll('a[href="#coming-soon"]');
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      let popupOverlay = document.querySelector('#forms-overlay');
      popupOverlay.setAttribute('data-cta-target', '#coming-soon-popup');
      document.querySelector('#coming-soon-popup').style.display = "flex";
      popupOverlay.style.display = "block";
      document.body.style.overflow = "hidden";
    });
  });
});

document.querySelectorAll('#black-overlay, .form-close').forEach((element) => {
  element.addEventListener('click', () => {
    let popupOverlay = document.querySelector('#forms-overlay');
    document.querySelectorAll('.form-popup').forEach((element) => {
      element.style.display = "none";
    });
    popupOverlay.style.display = "none";
    document.body.style.overflow = "auto";
  });
});

document.querySelectorAll('a[data-cta-type="js-whatsapp-open"]').forEach((element) => {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    dfToggle();
  });
});


document.querySelectorAll('a[data-cta-type="js-freshchat-open"]').forEach((element) => {
  element.addEventListener('click', function (event) {
    event.preventDefault();
    // event.stopPropagation();
    openFreshChat();
  });
});

function openFreshChat() {

  console.time('Freshchat total load time');
  Freshchat.open();
  Freshchat.call(() => {
    console.timeEnd('Freshchat total load time');
    console.log('Freshchat is now open!');
  });
  const drawerCloseButton = document.querySelector("drawer-close-button");
  drawerCloseButton.click();

  /*var fcFrame = document.querySelector("#fc_frame");
  fcFrame.style.display = "block";
  if (window.fcWidget) {
    window.fcWidget.open();
    window.fcWidget.show();
  }*/
}

document.addEventListener('DOMContentLoaded', function () {

  /* Manage Quick Links */
  if (window.location.href.includes("/#callme")) {
    var callBackButton = document.querySelector('a[data-cta-type="js-form-popup"][data-cta-target="#callmeback-popup"]');
    if (callBackButton) {
      callBackButton.click();
    }
  } else if (window.location.href.includes("#livechat")) {
    var check = setInterval(function () {
      if (typeof window.fcWidget !== 'undefined' && document.querySelector("#fc_frame") != null) {
        clearInterval(check);
        openFreshChat();
      };
    }, 200);
  } else if (window.location.href.includes("/#cart")) {
    var cartButton = document.querySelector('#cart-icon-bubble');
    if (cartButton) {
      cartButton.click();
    }
  } else if (window.location.href.includes("/#submit-review")) {
    let popupOverlay = document.querySelector('#forms-overlay');
    popupOverlay.setAttribute('data-cta-target', '#form-submit-review-popup');
    document.querySelector('#submit-review-popup').style.display = "flex";
    popupOverlay.style.display = "block";
    document.body.style.overflow = "hidden";
  }

  const kwesForms = document.querySelectorAll('.kwes-form');

  function kwesFormEventListener(event) {
    const form = event.target;
    const elements = form.querySelectorAll('.form-element');
    elements.forEach(function (element) {
      element.style.display = 'none';
    });
  }

  kwesForms.forEach(function (form) {
    form.addEventListener('kwSubmitted', kwesFormEventListener);
  });

});